<template>
  <div class="relative inline-flex items-center justify-center">
    <TMTertiaryButton
      :icon-size="IconSize.LG"
      icon-pos="left"
      icon="chatBubble"
      :class="`!${iconColor} p-0 w-full h-full`"
      @click="showPointerSubtaskModal = true"
    />
    <span class="text-notification-counter top-counter-position-btn">{{
      totalPointerSubtasks
    }}</span>
    <TextingNotificationsModal
      :subtasks="pointerSubtasks"
      :is-open="showPointerSubtaskModal"
      :total-pointer-subtasks="totalPointerSubtasks"
      @close="showPointerSubtaskModal = false"
    />
  </div>
</template>

<script lang="ts">
import TMTertiaryButton from '@nashville/button/TMTertiaryButton.vue'
import { defineComponent } from 'vue'
import { setup } from './controller'
import TextingNotificationsModal from './TextingNotificationsModal/TextingNotificationsModal.vue'

export default defineComponent({
  components: {
    TMTertiaryButton,
    TextingNotificationsModal,
  },
  setup,
})
</script>

<style lang="scss">
.text-notification-counter {
  @apply absolute left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none font-bold text-nash-neutral000 text-xs;
}

.top-counter-position-btn {
  // needed to vertically center number due to font and icon size differences
  top: 43%;
}
</style>
